import {
    TYPES,
    SAVE_ACTIVITY,
    PENDING_ACTIVITY,
    MARK_ATTENDANCE,
    IS_CHECKOUT,
    SAVE_TOLL,
    TOLL_LIST,
    TOLL_VIEW,
    TOLL_FILTER,
    APPROVAL_PENDING_LIST,
    APPROVAL_ACTIVITY,
    FSE,
    AM,
    AM_TOLL,
    AM_TOLL_MONTHLY_PLAN,
    PJP_REVIEW,
    PJP_PENDING_LIST,
    PJP_PENDING_APPROVE,
    FSE_OTP_GENERATE,
    SAVE_FSE,
    FSEs_DETAILS_BY_PJP_ID,
    PJP_DETAILS_BY_ID,
    FSE_INVENTORY,
    FSE_ACTIVATION_CHECK,
    INACTIVE_FSE,
    FSE_TAG_TRANSFER,
    CALL_LOGS,
    TOLL_PENDING_MEETING,
    NEAREST_PLAZA_FROM_OPERATOR,
    SBI_ISSUANCE
} from "./type";
import {checkSBIIssuanceRequest} from "./action";

const initialState = {
    types:[],
    saveActivityResponse:[],
    pendingActivity:[],
    attendance:[],
    isCheckout:[],
    saveToll:[],
    tollList:[],
    tollView:[],
    filter:[],
    approvalPendingList:[],
    approved:[],
    fseDetails:[],
    allAm:[],
    amTollDetails:[],
    monthlyPlan:[],
    PJPReviewDetails: [],
    PJPPendingList: [],
    PJPApprovalDetails: [],
    fseOTPResponse: [],
    saveFses: [],
    fseDetailsByPJPID: [],
    getFseActivationCheckResponse: [],
    getFseInventoryResponse: [],
    getInactiveFsesResponse: [],
    getFseTagTransferResponse: [],
    callLogsResponse: [],
    tollPendingMeetingResponse: [],
    nearestPlazaFromOperatorLocationResponse: [],
    checkSBIIssuanceResponse: []
};

const FasttagToll = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case TYPES:
            return {
                ...state,
                types: payload,
            };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveActivityResponse: payload,
            };
        case PENDING_ACTIVITY:
            return {
                ...state,
                pendingActivity: payload,
            };
        case MARK_ATTENDANCE:
            return {
                ...state,
                attendance: payload,
            };
        case IS_CHECKOUT:
            return {
                ...state,
                isCheckout: payload,
            };
        case SAVE_TOLL:
            return {
                ...state,
                saveToll: payload,
            };
        case TOLL_LIST:
            return {
                ...state,
                tollList: payload,
            };
        case TOLL_VIEW:
            return {
                ...state,
                tollView: payload,
            };
        case TOLL_FILTER:
            return {
                ...state,
                filter: payload,
            };
        case APPROVAL_PENDING_LIST:
            return {
                ...state,
                approvalPendingList: payload,
            };
        case APPROVAL_ACTIVITY:
            return {
                ...state,
                approved: payload,
            };
        case FSE:
            return {
                ...state,
                fseDetails: payload,
            };
        case AM:
            return {
                ...state,
                allAm: payload,
            };
        case AM_TOLL:
            return {
                ...state,
                amTollDetails: payload,
            };
        case AM_TOLL_MONTHLY_PLAN:
            return {
                ...state,
                monthlyPlan: payload,
            };
        case PJP_REVIEW:
            return {
                ...state,
                PJPReviewDetails: payload,
            };
        case PJP_PENDING_LIST:
            return {
                ...state,
                PJPPendingList: payload,
            };
        case PJP_PENDING_APPROVE:
            return {
                ...state,
                PJPApprovalDetails: payload,
            };
        case FSE_OTP_GENERATE:
            return {
                ...state,
                fseOTPResponse: payload,
            };
        case SAVE_FSE:
            return {
                ...state,
                saveFses: payload,
            };
        case FSEs_DETAILS_BY_PJP_ID:
            return {
                ...state,
                fseDetailsByPJPID: payload,
            };
        case PJP_DETAILS_BY_ID:
            return {
                ...state,
                PJPDetailsByD: payload,
            };
        case INACTIVE_FSE:
            return {
                ...state,
                getInactiveFsesResponse: payload,
            };
        case FSE_INVENTORY:
            return {
                ...state,
                getFseInventoryResponse: payload,
            };
        case FSE_ACTIVATION_CHECK:
            return {
                ...state,
                getFseActivationCheckResponse: payload,
            };
        case FSE_TAG_TRANSFER:
            return {
                ...state,
                getFseTagTransferResponse: payload,
            };
        case CALL_LOGS:
            return {
                ...state,
                callLogsResponse: payload,
            };
        case TOLL_PENDING_MEETING:
            return {
                ...state,
                tollPendingMeetingResponse: payload,
            };
        case NEAREST_PLAZA_FROM_OPERATOR:
            return {
                ...state,
                nearestPlazaFromOperatorLocationResponse: payload,
            };
            case SBI_ISSUANCE:
            return {
                ...state,
                checkSBIIssuanceResponse: payload,
            };
        default:
            return {...state};
    }
};

export default FasttagToll;